import React from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { useOpenFocusConfigurator } from '../../../../FocusMode/components/FocusConfigurator/FocusConfigurator'

export const Focus = () => {
  const openFocusConfigurator = useOpenFocusConfigurator()

  return (
    <TtTooltip
      content={intl.formatMessage({ defaultMessage: 'Start Focus Mode' })}
      placement="left"
      distance={16}
    >
      <TtButton circle color="secondary" onClick={openFocusConfigurator}>
        <TtIcon library="one/webinars" name="presentation" />
      </TtButton>
    </TtTooltip>
  )
}
